 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"view-AccountHead-index-vue":"view-AccountHead-index-vue","view-AccountStatement-index-vue":"view-AccountStatement-index-vue","view-BalanceSheet-index-vue":"view-BalanceSheet-index-vue","view-BillingBook-index-vue":"view-BillingBook-index-vue","view-Category-index-vue":"view-Category-index-vue","view-CrNote-index-vue":"view-CrNote-index-vue","view-Customer-index-vue":"view-Customer-index-vue","view-DrNote-index-vue":"view-DrNote-index-vue","view-FiscalYear-index-vue":"view-FiscalYear-index-vue","view-GeneralPayment-index-vue":"view-GeneralPayment-index-vue","view-GeneralReciept-index-vue":"view-GeneralReciept-index-vue","view-IncomeExpenseReport-index-vue":"view-IncomeExpenseReport-index-vue","view-InventoryMapping-index-vue":"view-InventoryMapping-index-vue","view-Invoice-index-vue":"view-Invoice-index-vue","view-Item-create-vue":"view-Item-create-vue","view-Item-edit-vue":"view-Item-edit-vue","view-Item-index-vue":"view-Item-index-vue","view-JournalEntry-index-vue":"view-JournalEntry-index-vue","view-JournalList-index-vue":"view-JournalList-index-vue","view-LedgerHead-index-vue":"view-LedgerHead-index-vue","view-Login-vue":"view-Login-vue","view-MappingParam-index-vue":"view-MappingParam-index-vue","view-OpeningBalanceReport-index-vue":"view-OpeningBalanceReport-index-vue","view-PLAccount-index-vue":"view-PLAccount-index-vue","view-PaymentReceiptList-index-vue":"view-PaymentReceiptList-index-vue","view-PostOpening-index-vue":"view-PostOpening-index-vue","view-Profile-index-vue":"view-Profile-index-vue","view-Profile-modules-PasswordUpdate-vue":"view-Profile-modules-PasswordUpdate-vue","view-Profile-modules-PersonalUpdate-vue":"view-Profile-modules-PersonalUpdate-vue","view-Profile-modules-personal-vue":"view-Profile-modules-personal-vue","view-Purchase-create-vue":"view-Purchase-create-vue","view-Purchase-index-vue":"view-Purchase-index-vue","view-Purchase-index1-vue":"view-Purchase-index1-vue","view-Purchase-return-report-vue":"view-Purchase-return-report-vue","view-Purchase-return-vue":"view-Purchase-return-vue","view-Router-vue":"view-Router-vue","view-Sales-create-vue":"view-Sales-create-vue","view-Sales-index-vue":"view-Sales-index-vue","view-Sales-return-report-vue":"view-Sales-return-report-vue","view-Sales-return-vue":"view-Sales-return-vue","view-SchoolPayment-index-vue":"view-SchoolPayment-index-vue","view-TrialBalance-index-vue":"view-TrialBalance-index-vue","view-Unit-index-vue":"view-Unit-index-vue","view-Warehouse-index-vue":"view-Warehouse-index-vue","view-dashboard-_components-index-vue":"view-dashboard-_components-index-vue","view-index-vue":"view-index-vue","view-journal_type-index-vue":"view-journal_type-index-vue","view-layout-_components-index-vue":"view-layout-_components-index-vue","view-mapfeehead-_components-index-vue":"view-mapfeehead-_components-index-vue"}[chunkId]||chunkId) + "." + {"view-AccountHead-index-vue":"fca2d332","view-AccountStatement-index-vue":"dd2f8ef9","view-BalanceSheet-index-vue":"43d98f72","view-BillingBook-index-vue":"7f5b0024","view-Category-index-vue":"b52664a9","view-CrNote-index-vue":"90dba20e","view-Customer-index-vue":"63d6c6bd","view-DrNote-index-vue":"f4ee773d","view-FiscalYear-index-vue":"ffc13430","view-GeneralPayment-index-vue":"0b346280","view-GeneralReciept-index-vue":"b5067002","view-IncomeExpenseReport-index-vue":"2fa40eb0","view-InventoryMapping-index-vue":"b13be1f9","view-Invoice-index-vue":"e0e73a09","view-Item-create-vue":"a1e79a2b","view-Item-edit-vue":"b8005b93","view-Item-index-vue":"60ea8099","view-JournalEntry-index-vue":"88363e68","view-JournalList-index-vue":"dd85a141","view-LedgerHead-index-vue":"77b86288","view-Login-vue":"ee3ec81e","view-MappingParam-index-vue":"769f233e","view-OpeningBalanceReport-index-vue":"8be603c3","view-PLAccount-index-vue":"7ed5b823","view-PaymentReceiptList-index-vue":"015fd774","view-PostOpening-index-vue":"5620cf2a","view-Profile-index-vue":"f1cdbd64","view-Profile-modules-PasswordUpdate-vue":"69ca3fc9","view-Profile-modules-PersonalUpdate-vue":"3b4b7ef0","view-Profile-modules-personal-vue":"a00a2f2d","view-Purchase-create-vue":"b41cff33","view-Purchase-index-vue":"0368b58f","view-Purchase-index1-vue":"83aa7030","view-Purchase-return-report-vue":"91872a00","view-Purchase-return-vue":"d5b9926c","view-Router-vue":"7472e6dd","view-Sales-create-vue":"76327970","view-Sales-index-vue":"6bebbb6e","view-Sales-return-report-vue":"76b9f257","view-Sales-return-vue":"4f4cafa3","view-SchoolPayment-index-vue":"9ab33560","view-TrialBalance-index-vue":"6fc64aca","view-Unit-index-vue":"dc6cda06","view-Warehouse-index-vue":"63e01e37","view-dashboard-_components-index-vue":"40101ebb","view-index-vue":"1c9d6280","view-journal_type-index-vue":"af561763","view-layout-_components-index-vue":"922e93b5","view-mapfeehead-_components-index-vue":"7d4d9111"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"view-AccountStatement-index-vue":1,"view-BalanceSheet-index-vue":1,"view-BillingBook-index-vue":1,"view-FiscalYear-index-vue":1,"view-GeneralPayment-index-vue":1,"view-GeneralReciept-index-vue":1,"view-Invoice-index-vue":1,"view-Item-create-vue":1,"view-Item-edit-vue":1,"view-Item-index-vue":1,"view-JournalEntry-index-vue":1,"view-Login-vue":1,"view-PLAccount-index-vue":1,"view-Profile-index-vue":1,"view-Purchase-create-vue":1,"view-Purchase-index-vue":1,"view-Purchase-return-report-vue":1,"view-Purchase-return-vue":1,"view-Sales-create-vue":1,"view-Sales-index-vue":1,"view-Sales-return-report-vue":1,"view-Sales-return-vue":1,"view-SchoolPayment-index-vue":1,"view-TrialBalance-index-vue":1,"view-dashboard-_components-index-vue":1,"view-index-vue":1,"view-journal_type-index-vue":1,"view-layout-_components-index-vue":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"view-AccountHead-index-vue":"view-AccountHead-index-vue","view-AccountStatement-index-vue":"view-AccountStatement-index-vue","view-BalanceSheet-index-vue":"view-BalanceSheet-index-vue","view-BillingBook-index-vue":"view-BillingBook-index-vue","view-Category-index-vue":"view-Category-index-vue","view-CrNote-index-vue":"view-CrNote-index-vue","view-Customer-index-vue":"view-Customer-index-vue","view-DrNote-index-vue":"view-DrNote-index-vue","view-FiscalYear-index-vue":"view-FiscalYear-index-vue","view-GeneralPayment-index-vue":"view-GeneralPayment-index-vue","view-GeneralReciept-index-vue":"view-GeneralReciept-index-vue","view-IncomeExpenseReport-index-vue":"view-IncomeExpenseReport-index-vue","view-InventoryMapping-index-vue":"view-InventoryMapping-index-vue","view-Invoice-index-vue":"view-Invoice-index-vue","view-Item-create-vue":"view-Item-create-vue","view-Item-edit-vue":"view-Item-edit-vue","view-Item-index-vue":"view-Item-index-vue","view-JournalEntry-index-vue":"view-JournalEntry-index-vue","view-JournalList-index-vue":"view-JournalList-index-vue","view-LedgerHead-index-vue":"view-LedgerHead-index-vue","view-Login-vue":"view-Login-vue","view-MappingParam-index-vue":"view-MappingParam-index-vue","view-OpeningBalanceReport-index-vue":"view-OpeningBalanceReport-index-vue","view-PLAccount-index-vue":"view-PLAccount-index-vue","view-PaymentReceiptList-index-vue":"view-PaymentReceiptList-index-vue","view-PostOpening-index-vue":"view-PostOpening-index-vue","view-Profile-index-vue":"view-Profile-index-vue","view-Profile-modules-PasswordUpdate-vue":"view-Profile-modules-PasswordUpdate-vue","view-Profile-modules-PersonalUpdate-vue":"view-Profile-modules-PersonalUpdate-vue","view-Profile-modules-personal-vue":"view-Profile-modules-personal-vue","view-Purchase-create-vue":"view-Purchase-create-vue","view-Purchase-index-vue":"view-Purchase-index-vue","view-Purchase-index1-vue":"view-Purchase-index1-vue","view-Purchase-return-report-vue":"view-Purchase-return-report-vue","view-Purchase-return-vue":"view-Purchase-return-vue","view-Router-vue":"view-Router-vue","view-Sales-create-vue":"view-Sales-create-vue","view-Sales-index-vue":"view-Sales-index-vue","view-Sales-return-report-vue":"view-Sales-return-report-vue","view-Sales-return-vue":"view-Sales-return-vue","view-SchoolPayment-index-vue":"view-SchoolPayment-index-vue","view-TrialBalance-index-vue":"view-TrialBalance-index-vue","view-Unit-index-vue":"view-Unit-index-vue","view-Warehouse-index-vue":"view-Warehouse-index-vue","view-dashboard-_components-index-vue":"view-dashboard-_components-index-vue","view-index-vue":"view-index-vue","view-journal_type-index-vue":"view-journal_type-index-vue","view-layout-_components-index-vue":"view-layout-_components-index-vue","view-mapfeehead-_components-index-vue":"view-mapfeehead-_components-index-vue"}[chunkId]||chunkId) + "." + {"view-AccountHead-index-vue":"31d6cfe0","view-AccountStatement-index-vue":"6f2c1cd3","view-BalanceSheet-index-vue":"33106546","view-BillingBook-index-vue":"03a4d6fb","view-Category-index-vue":"31d6cfe0","view-CrNote-index-vue":"31d6cfe0","view-Customer-index-vue":"31d6cfe0","view-DrNote-index-vue":"31d6cfe0","view-FiscalYear-index-vue":"0e433876","view-GeneralPayment-index-vue":"a4d4660f","view-GeneralReciept-index-vue":"f0cd03fc","view-IncomeExpenseReport-index-vue":"31d6cfe0","view-InventoryMapping-index-vue":"31d6cfe0","view-Invoice-index-vue":"977887ac","view-Item-create-vue":"a01334d9","view-Item-edit-vue":"7b247719","view-Item-index-vue":"7751e002","view-JournalEntry-index-vue":"dd367fb1","view-JournalList-index-vue":"31d6cfe0","view-LedgerHead-index-vue":"31d6cfe0","view-Login-vue":"14b59829","view-MappingParam-index-vue":"31d6cfe0","view-OpeningBalanceReport-index-vue":"31d6cfe0","view-PLAccount-index-vue":"151eadd3","view-PaymentReceiptList-index-vue":"31d6cfe0","view-PostOpening-index-vue":"31d6cfe0","view-Profile-index-vue":"2a48ecb1","view-Profile-modules-PasswordUpdate-vue":"31d6cfe0","view-Profile-modules-PersonalUpdate-vue":"31d6cfe0","view-Profile-modules-personal-vue":"31d6cfe0","view-Purchase-create-vue":"11e13be6","view-Purchase-index-vue":"d63e937a","view-Purchase-index1-vue":"31d6cfe0","view-Purchase-return-report-vue":"d63e937a","view-Purchase-return-vue":"5222808b","view-Router-vue":"31d6cfe0","view-Sales-create-vue":"85506e14","view-Sales-index-vue":"d63e937a","view-Sales-return-report-vue":"d63e937a","view-Sales-return-vue":"f91965ab","view-SchoolPayment-index-vue":"0e433876","view-TrialBalance-index-vue":"07354132","view-Unit-index-vue":"31d6cfe0","view-Warehouse-index-vue":"31d6cfe0","view-dashboard-_components-index-vue":"65896a86","view-index-vue":"65896a86","view-journal_type-index-vue":"5aae9c9a","view-layout-_components-index-vue":"9586a9fc","view-mapfeehead-_components-index-vue":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
